let globalRefetch: (() => void) | null = null;

/** Called from {@link ReadyForBillingWorkOrderCountProvider} only. */
export function setReadyForBillingWorkOrderCountRefetch(
  fn: (() => void) | null,
): void {
  globalRefetch = fn;
}

/**
 * Refetch ready-for-billing work order count (sidebar badge). Call after any
 * lifecycle action that can move a work order into or out of READY_FOR_BILLING.
 */
export function invalidateReadyForBillingWorkOrderCount(): void {
  globalRefetch?.();
}
